import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLoaded, userLoggedOut } from "~/slices/userSlice";
import type { AppDispatch } from "~/store";
import { jwtDecode } from 'jwt-decode';
export const useInitializeUser = () => {
  const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
  useEffect(() => {
    const initializeUser = () => {
      // if (process.env.NODE_ENV === 'development') {
      //   return 
      // }
      try {
        const storedUser = localStorage.getItem("currentUser");
        // console.log("Stored user from localStorage:", storedUser);
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          // console.log("Parsed user:", parsedUser);
          const token = parsedUser.user.token; // Extract token if available
          const decoded = jwtDecode(token) as any;
          // console.log("Decoded token:", decoded);
            if (decoded && decoded.exp) {
            // Check time remaining
            const currentTime = Math.floor(Date.now() / 1000);
            const timeRemaining = decoded.exp - currentTime;
            if (timeRemaining > 0) {
              dispatch(userLoaded(parsedUser));
            //   console.log("User initialized from localStorage:", parsedUser);
            } else {
              console.log("Token has expired");
              dispatch(userLoggedOut());
              navigate("/");
            }
          }
        } else {
          console.log("No stored user found in localStorage");
          navigate("/");
        }
      } catch (error) {
        console.error("Failed to parse stored user from localStorage:", error);
        // Clear invalid localStorage data
        // localStorage.removeItem("currentUser");
      }
    };

    initializeUser();
  }, [dispatch]);
};

export default useInitializeUser;
